<template>
  <VLayout
    v-update-main-height
    column
    justify-end
    fill-height
  >
    <VFlex
      xs12
    >
      <VTabs
        centered
        color="grey lighten-4"
        icons-and-text
        slider-color="blue"
        @change="onTabChanged"
      >
        <VTab href="#tab-1">
          Group ({{ getTotalGroups("tab-1") }})
          <VIcon>groups</VIcon>
        </VTab>
        <VTabItem
          v-for="i in 1"
          :key="i"
          :value="'tab-' + i"
        >
          <VCard
            flat
            :height="window.height"
            style="overflow: auto"
          >
            <ListViewPage
              :get-gql-query="getGqlQuery"
              :get-current-table-data="getCurrentTableData"
              :get-query-variables="getQueryVariables"
              :update-context-variable="updateContextVariable"
              :fetching-more="isFetchingMore"
              :get-loading-status="getLoadingStatus"
              :set-loading-status="setLoadingStatus"
              :get-status-message="getStatusMessage"
              :set-status-message="setStatusMessage"
              :parse-get-data="parseData"
              :clear-data="clearData"
            >
              <template slot="table">
                <GroupTable
                  @fetchingMore="onFetchingMore"
                />
              </template>
            </ListViewPage>
          </VCard>
        </VTabItem>
      </VTabs>
    </VFlex>
  </VLayout>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { groupMapActions } from '@/store/utils'
import ListViewPage from '@/pages/ListViewPage'
import GroupTable from '@/components/GroupTable'
import { LIST_GROUPS } from '@/backend/graphql/groupGQL'
export default {
  name: 'GroupsPage',
  components: {
    GroupTable, ListViewPage
  },
  directives: {
    'update-main-height': {
      inserted: function (el, binding, vnode) {
        const self = vnode.context
        self.window.initialHeight = el.parentElement.parentElement.clientHeight
        self.window.height = self.window.initialHeight - 93
      }
    }
  },
  data: function () {
    return {
      currentTab: 'tab-1',
      getGqlQuery: LIST_GROUPS,
      limit: 50,
      offset: 0,
      orderBy: 'name',
      isDelete: 0,
      isFetchingMore: false,
      window: {
        width: 0,
        height: 0,
        initialHeight: 0
      }
    }
  },
  computed: {
    ...mapGetters({ allGroups: 'group/getAllGroups' })
  },
  created () {
    this.setStatusMessage('Loading Groups. Please wait...')
    window.addEventListener('resize', this.handleResize)
    this.handleResize()
    this.setEditMenuItems({ val: [] })
    this.setMessageDrawerVisibility({ val: false })
  },
  destroyed () {
    window.removeEventListener('resize', this.handleResize)
  },
  methods: {
    ...mapActions(Object.assign(groupMapActions,
      { setEditMenuItems: 'toolBar/setEditMenuItems',
        setMessageDrawerVisibility: 'messageDrawer/setVisibility'
      })),
    getItems (data) { return data.listGroups.results },
    getCurrentTableData () { return this.allGroups },
    getTotalItemsCount (data) { return data.listGroups.totalCount },
    getLoadingStatus () { return this.$store.getters['group/getLoadingStatus'] },
    setLoadingStatus (val) { this.$store.dispatch('group/setLoadingStatus', { val }) },
    getStatusMessage () { return this.$store.getters['group/getLoadingText'] },
    setStatusMessage (message) { this.$store.dispatch('group/setStatusMessage', { message }) },
    parseData (data) {
      if (this.allGroups.length === 0) {
        this.initGroups({
          newGroups: this.getItems(data),
          totalCount: this.getTotalItemsCount(data),
          isFullArraySize: false
        })
      } else {
        this.appendGroups({
          newGroups: this.getItems(data),
          startIndex: this.getQueryVariables().offset
        })
        this.isFetchingMore = false
      }
    },
    getQueryVariables () {
      return {
        limit: this.limit,
        offset: this.offset,
        orderBy: this.orderBy,
        isDelete: this.isDelete
      }
    },
    updateContextVariable (key, value) {
      if (this.hasOwnProperty(key)) {
        this[key] = value
      }
    },
    clearData () { this.clearGroups() },
    onFetchingMore () {
      if (!this.isFetchingMore) {
        this.isFetchingMore = true
      }
    },
    getTotalGroups (value) {
      if (value === this.currentTab) {
        return this.$store.getters['group/getTotalCount']
      } else {
        return '?'
      }
    },
    onTabChanged (value) {
      this.currentTab = value
    },
    handleResize () {
      this.window.width = window.innerWidth
    }
  }
}
</script>

<style scoped>

</style>
